import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FuelTypography } from '@frete.com/fuel-react';

function NotificationError() {
  const { formState } = useFormContext();
  const errorReasonMessage = (formState.errors.reason?.message || '') as string;

  if (!errorReasonMessage) {
    return null;
  }

  return (
    <FuelTypography
      color="danger-default"
      size="caption"
      weight="bold"
      spacingTop={16}
    >
      {errorReasonMessage}
    </FuelTypography>
  );
}

export default NotificationError;
